var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockFillpaypg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 10.125C2.8125 9.52826 3.04955 8.95597 3.47151 8.53401C3.89347 8.11205 4.46576 7.875 5.0625 7.875H12.9375C13.5342 7.875 14.1065 8.11205 14.5285 8.53401C14.9504 8.95597 15.1875 9.52826 15.1875 10.125V15.75C15.1875 16.3467 14.9504 16.919 14.5285 17.341C14.1065 17.7629 13.5342 18 12.9375 18H5.0625C4.46576 18 3.89347 17.7629 3.47151 17.341C3.04955 16.919 2.8125 16.3467 2.8125 15.75V10.125Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0625 4.5C5.0625 3.45571 5.47734 2.45419 6.21577 1.71577C6.95419 0.977343 7.95571 0.5625 9 0.5625C10.0443 0.5625 11.0458 0.977343 11.7842 1.71577C12.5227 2.45419 12.9375 3.45571 12.9375 4.5V7.875H11.8125V4.5C11.8125 3.75408 11.5162 3.03871 10.9887 2.51126C10.4613 1.98382 9.74592 1.6875 9 1.6875C8.25408 1.6875 7.53871 1.98382 7.01126 2.51126C6.48382 3.03871 6.1875 3.75408 6.1875 4.5V7.875H5.0625V4.5Z",
    fill: "#616161"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockFillpaypg);
export default __webpack_public_path__ + "static/media/LockFillpaypg.d343a8714879d11ce4ab537a8759e96b.svg";
export { ForwardRef as ReactComponent };